import { bootMode } from './maintenance/boot';

// The literal comparison lets Rollup drop the app chunk from a maintenance build.
if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
  import('./maintenance/bootstrap').then(({ mount }) => mount('maintenance'));
} else {
  const mode = bootMode(import.meta.env.VITE_MAINTENANCE_MODE, window.location.pathname);
  if (mode === 'app') {
    import('./AppRoot');
  } else {
    import('./maintenance/bootstrap').then(({ mount }) => mount(mode));
  }
}
